import React from 'react';
import { Accordion, AccordionItem } from './Accordion';
import { countyCities } from '../data/serviceAreas';
export function ServiceAreaAccordion() {
  return <Accordion data-id="element-231" data-mp="2lq9lgbp2xxjb">
      {countyCities.map((area, i) => <AccordionItem key={area.county} title={area.county} meta={`${area.cities.length} cities`} defaultOpen={i === 0} data-id="element-232" data-mp="2gpve6vvayrmc" data-mpi={i}>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm text-steel-500 sm:grid-cols-3 lg:grid-cols-4" data-id="element-233" data-mp="39e0xrfameakl">
            {area.cities.map(city => <li key={city} className="border-l-2 border-steel-200 pl-2.5" data-id="element-234" data-mp="34ghjwghu3zt6">
                {city}
              </li>)}
          </ul>
        </AccordionItem>)}
    </Accordion>;
}